import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { State } from '../../reducers';
import { Plant } from '@cemex-core/cmx-api';
import { getOneClickPlants } from '../../selectors/one-click-plants.selector';
import { OneClickSelectPlantsAction } from '../../actions/one-click-plants.actions';

@Injectable()
export class OneClickSyncPlant implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: Plant, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOneClickPlants(form.mapItem['index'])),
        filter((plants) => !!value && !!plants && !!plants.length),
        take(1),
      )
      .subscribe((product) => {
        this.store.dispatch(new OneClickSelectPlantsAction(value, form.mapItem['index']));
      });
  }
}
